import * as yup from 'yup'
import { defineMessages } from 'react-intl'
import { isEmpty } from 'lodash'

const companyMessages = defineMessages({
  required: {
    id: 'sites.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'items.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'items.form.name.max',
    defaultMessage: 'The name can be up to 55 characters'
  }
})

const typeMessages = defineMessages({
  required: {
    id: 'items.form.type.required',
    defaultMessage: 'The type is required'
  }
})

const line1Messages = defineMessages({
  max: {
    id: 'inventories.address.line1.max',
    defaultMessage: 'The street can be up to 255 characters'
  }
})

const line2Messages = defineMessages({
  max: {
    id: 'inventories.address.line2.max',
    defaultMessage: 'The additional information can be up to 255 characters'
  }
})

const zipCodeMessages = defineMessages({
  regex: {
    id: 'inventories.address.zipCode.regex',
    defaultMessage: 'The format for a ZIP code is wrong'
  }
})

const testRequired = (value: TSFixMe, isEdit: TSFixMe): TSFixMe => {
  if (!isEdit) {
    return !isEmpty(value)
  }

  return true
}

export const schema = (intl: TSFixMe, isEdit: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().test('is-company-required', intl.formatMessage(companyMessages.required), function (value) {
        return testRequired(value, isEdit)
      })
    }),
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(55, intl.formatMessage(nameMessages.max)),
    type: yup.string().required(intl.formatMessage(typeMessages.required)),
    address: yup.object().shape({
      line1: yup.string().max(255, intl.formatMessage(line1Messages.max)),
      line2: yup.string().max(255, intl.formatMessage(line2Messages.max)),
      city: yup.object().shape({
        id: yup.string()
      }),
      zipCode: yup.string().matches(/^([a-za-z0-9]{5,15})*$/, intl.formatMessage(zipCodeMessages.regex))
    })
  })
}
